import React from "react";

const Banner = () => {
  return (
    <>
      <div className="banner">
        <div className="container1">
          <div className="banner-content">
            <h2>DEAR USERS, FIND OUT WHAT MAKES US DIFFERENT</h2>
            <h3>
              WE BELIEVE THAT PERSONALIZATION IS NOT ABOUT FIRST/LAST NAMES.
              IT’S ABOUT RELEVANT CONTENT:
            </h3>
            <p>
              On the surface, email marketing seems to be an easy task -
              crafting an attractive mailer and sending them out to as many
              contacts as possible. But when there are a variety of companies
              across a variety of industries doing the same, content becomes
              critical. Content represents all forms of media including graphics
              and verbal communication. It needs to be relevant, fresh, and
              consistent, to do so, market research is necessary. It is
              important to understand fundamental questions like ‘What fits?’ ,
              ‘Where?’ etc. That’s where the proficiency of Bud, the top email
              marketing company in India comes into play. We can deliver
              exceptional results to drive your business forward.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
